import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface UpdateShowPrepConductorAwarenessParams {
  readonly enabled: boolean;
}

export class UpdateShowPrepConductorAwarenessRequest extends Request<UpdateShowPrepConductorAwarenessParams, IResult> {
  constructor(params: UpdateShowPrepConductorAwarenessParams) {
    super('updateShowPrepConductorAwareness', params);
  }
}
